<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">Pravila za stavke – račun {{ data.companyAccount }}</span>
    <mat-icon class="h-24-w-24 cursor-pointer" (click)="close()">close</mat-icon>
  </div>

  <p class="hint">
    Pravila se primjenjuju samo na izvode ovog računa. Ako više pravila odgovara
    istoj stavci, primjenjuje se najnovije pravilo.
  </p>

  <div class="toolbar">
    <button class="primary-button" (click)="openRuleDialog()">
      <mat-icon>add</mat-icon>
      <span class="ml-8">Novo pravilo</span>
    </button>
  </div>

  <div *ngIf="loading" class="state">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div *ngIf="!loading && !rules.length" class="state">
    Nema pravila za ovaj račun.
  </div>

  <div *ngIf="!loading && rules.length" class="rules-table-wrapper">
    <table class="rules-table">
      <thead>
        <tr>
          <th>Uslov</th>
          <th>Konto</th>
          <th>Partner</th>
          <th>Kreirano</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rule of rules">
          <td>
            <div class="condition" *ngFor="let c of conditionSummary(rule)">
              <span class="condition-label">{{ c.label }}:</span>
              <span class="condition-value" [matTooltip]="c.value">{{ c.value }}</span>
            </div>
          </td>
          <td [matTooltip]="kontoLabel(rule.konto)">{{ rule.konto || '–' }}</td>
          <td [matTooltip]="partnerLabel(rule.partnerCode)">{{ partnerLabel(rule.partnerCode) || '–' }}</td>
          <td class="nowrap">{{ rule.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
          <td class="actions">
            <mat-icon class="cursor-pointer" matTooltip="Uredi" (click)="openRuleDialog(rule)">edit</mat-icon>
            <mat-icon
              class="cursor-pointer delete"
              matTooltip="Obriši"
              [class.disabled]="deletingId === rule.id"
              (click)="deleteRule(rule)"
            >delete</mat-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
